import { Injectable } from '@angular/core';
import {
    IValueType,
    TComputeValueInput
} from "libraries/pipes/configurable-table/compute-value.pipe";
import { DatePipe } from "@angular/common";
import { IGetBookingsAirResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { BookingType } from "@afidium/ts-facade";
import { SectorInBookingType } from "@afidium/ts-facade/model/sectorInBookingType";

@Injectable()
export class ComputeValueHelperService {

    constructor(
        private readonly datePipe: DatePipe,
    ) {
    }

    public transformDate(element: TComputeValueInput, path: string = null, date: string = null, format: string = 'shortDate'): IValueType {
        const dateString: string = date || element[path]?.date;
        return dateString ? {
            value: this.datePipe.transform(
                dateString,
                format,
            ),
            type: 'string'
        } : null;
    }

    public transformFareOptimisation(element: IGetBookingsAirResponse, type: "summary" | "list"): IValueType {
        return element.booking?.fareOptimisation ? {
                booking: element.booking,
                fareOptimisation: element.booking.fareOptimisation,
                value: 'fake',
                type: type === "list" ? 'fareOptimisationList' : "fareOptimisationSummary",
            } :
            null;
    }
}
